import {
  getUsers,
  searchUsers,
  setUserLicense,
  UserRecord,
} from "../services/admin-user-service";

export function renderUsersPage(): string {
  return `
    <div class="admin-page">
      <div class="admin-container">
        <h1>Users</h1>
        <div class="admin-toolbar">
          <input type="text" id="user-search" class="admin-search" placeholder="Search by email..." />
          <button class="admin-btn admin-btn-outline" id="user-search-btn">Search</button>
          <button class="admin-btn admin-btn-outline" id="user-refresh-btn">Refresh</button>
        </div>
        <div id="users-table-container">
          <p class="admin-loading">Loading users...</p>
        </div>
      </div>
    </div>
  `;
}

export function mountUsersPage(): void {
  loadUsers();

  document.getElementById("user-search-btn")!.addEventListener("click", handleSearch);
  document.getElementById("user-refresh-btn")!.addEventListener("click", loadUsers);

  const searchInput = document.getElementById("user-search") as HTMLInputElement;
  searchInput.addEventListener("keypress", (e) => {
    if (e.key === "Enter") handleSearch();
  });
}

async function loadUsers(): Promise<void> {
  const container = document.getElementById("users-table-container")!;
  container.innerHTML = '<p class="admin-loading">Loading users...</p>';

  try {
    const { users } = await getUsers();
    renderUsersTable(users);
  } catch (err: any) {
    container.innerHTML = `<p class="admin-error">Failed to load users: ${err.message}</p>`;
  }
}

async function handleSearch(): Promise<void> {
  const query = (document.getElementById("user-search") as HTMLInputElement).value.trim();
  if (!query) {
    loadUsers();
    return;
  }

  const container = document.getElementById("users-table-container")!;
  container.innerHTML = '<p class="admin-loading">Searching...</p>';

  try {
    const users = await searchUsers(query);
    renderUsersTable(users);
  } catch (err: any) {
    container.innerHTML = `<p class="admin-error">Search failed: ${err.message}</p>`;
  }
}

function renderUsersTable(users: UserRecord[]): void {
  const container = document.getElementById("users-table-container")!;

  if (users.length === 0) {
    container.innerHTML = '<p class="admin-empty">No users found.</p>';
    return;
  }

  const rows = users
    .map(
      (u) => `
    <tr>
      <td>${escapeHtml(u.email)}</td>
      <td>${u.createdAt?.toDate?.()?.toLocaleDateString() || "N/A"}</td>
      <td>${u.enterpriseId || "N/A"}</td>
      <td><span class="admin-badge ${u.licensed ? "admin-badge-success" : "admin-badge-muted"}">${u.licensed ? "Yes" : "No"}</span></td>
      <td><button class="admin-btn admin-btn-sm ${u.licensed ? "admin-btn-danger" : "admin-btn-primary"}" data-license-uid="${u.uid}" data-license-action="${u.licensed ? "revoke" : "grant"}">${u.licensed ? "Revoke" : "Grant"}</button></td>
    </tr>
  `
    )
    .join("");

  container.innerHTML = `
    <table class="admin-table">
      <thead>
        <tr>
          <th>Email</th>
          <th>Created</th>
          <th>Enterprise</th>
          <th>Licensed</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>
  `;

  // Wire up license buttons
  container.querySelectorAll<HTMLButtonElement>("[data-license-uid]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const uid = btn.dataset.licenseUid!;
      const action = btn.dataset.licenseAction!;
      const licensed = action === "grant";

      btn.disabled = true;
      btn.textContent = licensed ? "Granting..." : "Revoking...";

      try {
        await setUserLicense(uid, licensed);
        loadUsers();
      } catch (err: any) {
        alert(`Failed to ${action} license: ${err.message}`);
        btn.disabled = false;
        btn.textContent = licensed ? "Grant" : "Revoke";
      }
    });
  });
}

function escapeHtml(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
